import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

// 白名单
const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  // document.title = to.meta.title || 'xxx'

  const hasToken = store.getters.token

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: store.getters.home })
      NProgress.done()
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
